import React from 'react';

const LmsEvent = () => {
  return (
    <iframe
      src="https://jebs-notice.oopy.io/b68dae28-f925-44c7-aaeb-ba5e2d12e279"
      className="h-[100vh] w-full border-0"
      title="notice"
    />
  );
};

export default LmsEvent;
